<template>
  <div class="reserv-box" v-if="restaurant_data">
    <div class="reserv-top">
      <div class="reserv-img"></div>
      <div class="reserv-info">
        <div class="reserv-rest-name">{{restaurant_data.user_property['Restaurant-Name']}}</div>
        <div class="reserv-status">
          <div v-if="reservation.valid && !reservation.cancelled"><i class="fa-solid fa-calendar-check confirmed"></i> Reservation Confirmed</div>
          <div v-else-if="reservation.valid && reservation.cancelled"><i class="fa-solid fa-calendar-xmark cancelled"></i> Reservation Cancelled</div>
        </div>
        <div class="reserv-time">
          <div class="res-det"><i class="far fa-calendar"></i>{{ formatDate(reservation.bookDate) }}</div>
          <div class="res-det"><i class="far fa-clock"></i> {{formatTime(reservation.bookDate)}}</div>
          <div class="res-det"><i class="far fa-user"></i> {{reservation.customer.seats}} {{reservation.customer.seats > 1 ? 'People' : 'Person'}}</div>
        </div>
        <div class="reserv-options">
          <!--  cancel müşteri tarafından yapılamıyor şuanda,
           reservation apisine tokensız reservation updatei eklemek gerek
           (validIpNeeded ile sadece turkishrestaurant.comdan alabiliriz isteği, yine de riskli),
           ya da turkish restaurant apisinde müşteri loginine user için reservation token koymak gerekiyor.
           Şuan reservation sisteminde rezervasyonu yapan kullanıcı için çalışan bi model yok. O yüzden Cancel iptal
           -->
<!--          <div class="cancel">Cancel</div>-->
          <div class="cancel"><a :href="toCalendar" target="_blank">
            Add to Calendar
          </a></div>
          <div class="view-details" @click="toggle = !toggle">{{ toggle ? 'Hide' : 'View' }} Details</div>
        </div>
      </div>
    </div>
    <div v-if="toggle" class="reserv-details">
      <div class="reserv-easy-nav">
        <div class="reserv-button" @click="viewMenu"><i class="fa-solid fa-book-open"></i> View Menu</div>
        <div class="reserv-button" @click="openMap"><i class="fa-solid fa-diamond-turn-right"></i> Directions</div>
      </div>
      <div class="reserv-notes">
        <h2>What to know before you go</h2>
        <div class="dining-info">
          <h2><i class="fas fa-info-circle"></i> Important Reservation Information</h2>
          <p>{{reservation.store.details.rules}}</p>
        </div>
        <div class="dining-info">
          <h2><i class="fas fa-exclamation-triangle"></i> A Note From The Restaurant</h2>
          <p>{{reservation.store.details.about}}</p>
        </div>
        <div class="dining-info">
          <h2><i class="fas fa-parking"></i> Parking</h2>
          <p>{{reservation.store.details.parking}}</p>
        </div>
      </div>
      <div class="reserv-footer">
        <h2>Contact Information</h2>
        <div class="reserv-contact-info">
          <div class="reserv-map">
            <restaurant-map ref="map" :restaurant_data="restaurant_data" />
          </div>
          <div class="reserv-footer-info">
            <div class="contact-info">{{ restaurant_data.user_property['Restaurant-Name'] }}</div>
            <div class="contact-info">{{ restaurant_data.user_property['Address'] }}</div>
            <div class="contact-info"><a class="res-call-button"  :href="`tel:${restaurant_data.phone}`"><div class="tr-res-detail-text"><i class="fa-solid fa-phone"></i>  {{ restaurant_data.phone }}</div></a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import RestaurantMap from '../products/RestaurantMap'
export default {
  props: {
    reservation: {
      type: Object
    }
  },
  components: {
    RestaurantMap
  },
  name: 'ReservationItem',
  data () {
    return {
      toggle: false,
      latitude: 37.7749,
      longitude: -122.4194,
      apiKey: process.env.VUE_APP_GOOGLE_KEY,
      restaurant_data: null
    }
  },
  computed: {
    mapUrl () {
      return `https://www.google.com/maps/embed/v1/view?key=${this.apiKey}&center=${this.latitude},${this.longitude}&zoom=15`
    },
    event () {
      return {
        title: `Reservation @${this.restaurant_data.user_property['Restaurant-Name']}`,
        start: this.reservation.bookDate,
        end: this.reservation.bookDate,
        description: 'Your table will be available for your arrival.',
        location: this.restaurant_data.user_property['Address']
      }
    },
    toCalendar () {
      const baseUrl = 'https://www.google.com/calendar/render'
      const params = {
        action: 'TEMPLATE',
        text: encodeURIComponent(this.event.title),
        dates: `${this.event.start}/${this.event.end}`,
        details: encodeURIComponent(this.event.description),
        location: encodeURIComponent(this.event.location)
      }
      const queryString = Object.keys(params)
        .map(key => `${key}=${params[key]}`)
        .join('&')
      return `${baseUrl}?${queryString}`
    }
  },
  mounted () {
  },
  watch: {
    toggle () {
    }
  },
  beforeMount () {
    this.getRestaurantbyEMail()
  },
  methods: {
    viewMenu () {
      this.$router.push({
        name: 'restaurant-products',
        params: {
          restaurant_id: String(this.restaurant_data.user_property['Alias'])
        }})
    },
    openMap () {
      this.$refs.map.mapClick()
    },
    getRestaurantbyEMail () {

      this.$vs.loading()

      const payload = {
        email: this.reservation.store.user.email
      }

      this.$store.dispatch('api/getRestaurantByEmail', payload)
        .then((response) => {
          this.restaurant_data = response.data.data[0]
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    formatDate (date) {
      return moment(date).format('ddd, MMM D')
    },
    formatTime (date) {
      return moment(date).format('hh:mm A')
    },
    addMarker () {
      const iframe = document.querySelector('iframe')
      const markerUrl = 'https://maps.google.com/mapfiles/kml/shapes/man.png'
      const markerHtml = `<img src="${markerUrl}" alt="marker"/>`
      const marker = new window.google.maps.Marker({
        position: { lat: this.latitude, lng: this.longitude },
        map: new window.google.maps.Map(iframe.contentWindow.document.body),
        icon: {
          url: markerUrl,
          size: new window.google.maps.Size(64, 64),
          origin: new window.google.maps.Point(0, 0),
          anchor: new window.google.maps.Point(32, 32)
        },
        title: 'Marker'
      })
      const infowindow = new window.google.maps.InfoWindow({
        content: markerHtml
      })
      marker.addListener('click', () => {
        infowindow.open(marker.get('map'), marker)
      })
    }
  }
}
</script>

<style scoped>

</style>
